module.exports = __webpack_public_path__ + "img/6.0efd2c4c.png";